
    if (!window.__XIBO_REDIRECTING) {
      import('/src/main.ts');
    }
  